import React, { useState } from 'react';
import ValidationErrors from '../common/ValidationErrors';
import { canchaService } from '../../services/canchaService';

const diasSemana = [
  { key: '1', label: 'Lunes' },
  { key: '2', label: 'Martes' },
  { key: '3', label: 'Miércoles' },
  { key: '4', label: 'Jueves' },
  { key: '5', label: 'Viernes' },
  { key: '6', label: 'Sábado' },
  { key: '7', label: 'Domingo' },
];

export default function CanchaForm({ onCreated, initialData }) {
  const [form, setForm] = useState(() => initialData ? {
    nombre: initialData.nombre || '',
    tipo: initialData.tipo || 'futbol',
    precio_por_hora: initialData.precio_por_hora || '',
    descripcion: initialData.descripcion || '',
    activa: typeof initialData.activa === 'boolean' ? initialData.activa : true,
    horarios_disponibles: initialData.horarios_disponibles || {},
    imagenes: initialData.imagenes || [],
  } : {
    nombre: '',
    tipo: 'futbol',
    precio_por_hora: '',
    descripcion: '',
    activa: true,
    horarios_disponibles: {},
    imagenes: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validationErrors, setValidationErrors] = useState(null);

  // IMAGENES: Manejo de archivos
  const handleImagenesChange = e => {
    const files = Array.from(e.target.files);
    Promise.all(files.map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    })).then(imagesBase64 => {
      setForm(prev => ({ ...prev, imagenes: imagesBase64 }));
    });
  };

  // AUTOFILL HORARIOS: Rellenar todos los días con el mismo horario del primer día
  const autofillHorarios = () => {
    const primerDia = diasSemana.find(dia => (form.horarios_disponibles[dia.key] && form.horarios_disponibles[dia.key].length > 0));
    if (!primerDia) return;
    const horarioBase = form.horarios_disponibles[primerDia.key];
    const nuevosHorarios = {};
    diasSemana.forEach(dia => {
      nuevosHorarios[dia.key] = horarioBase.map(h => ({ ...h }));
    });
    setForm(prev => ({ ...prev, horarios_disponibles: nuevosHorarios }));
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setValidationErrors(null);
    try {
      const payload = {
        nombre: form.nombre,
        tipo: form.tipo,
        precio_por_hora: form.precio_por_hora,
        descripcion: form.descripcion,
        activa: form.activa,
        horarios_disponibles: Object.keys(form.horarios_disponibles).length > 0 ? form.horarios_disponibles : undefined,
        imagenes: form.imagenes.length > 0 ? form.imagenes : undefined,
      };
      if (initialData && initialData.id) {
        await canchaService.actualizarCancha(initialData.id, payload);
      } else {
        await canchaService.crearCancha(payload);
      }
      setLoading(false);
      if (onCreated) onCreated(payload);
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || (initialData ? 'Error al editar la cancha' : 'Error al crear la cancha'));
      if (err.response?.data?.errors) {
        setValidationErrors(err.response.data.errors);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4 bg-white rounded shadow">
      <h2 className="text-xl font-bold mb-4">{initialData ? 'Editar Cancha' : 'Crear Cancha'}</h2>
      <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Nombre" required className="mb-2 w-full p-2 border" />
      <select name="tipo" value={form.tipo} onChange={handleChange} className="mb-2 w-full p-2 border">
        <option value="futbol">Fútbol</option>
        <option value="tenis">Tenis</option>
        <option value="basquet">Básquet</option>
        <option value="voley">Vóley</option>
      </select>
      <input name="precio_por_hora" type="number" value={form.precio_por_hora} onChange={handleChange} placeholder="Precio por hora" required className="mb-2 w-full p-2 border" />
      <textarea name="descripcion" value={form.descripcion} onChange={handleChange} placeholder="Descripción" className="mb-2 w-full p-2 border" />
      <label className="flex items-center mb-2">
        <input name="activa" type="checkbox" checked={form.activa} onChange={handleChange} />
        <span className="ml-2">Activa</span>
      </label>
      {/* Campo para subir imágenes */}
      <div className="mb-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">Imágenes de la cancha</label>
        <input type="file" multiple accept="image/*" onChange={handleImagenesChange} className="w-full p-2 border" />
        <div className="flex flex-wrap mt-2">
          {form.imagenes && form.imagenes.map((img, i) => (
            <img key={i} src={img} alt="preview" className="h-16 w-16 object-cover rounded mr-2 mb-2" />
          ))}
        </div>
        <small className="text-gray-500">Puedes subir varias imágenes propias de la cancha. Si no subes, se usarán las del establecimiento.</small>
      </div>
  {error && <div className="text-red-500 mb-2">{error}</div>}
  <ValidationErrors errors={validationErrors} />
      <button type="submit" disabled={loading} className="bg-blue-600 text-white px-4 py-2 rounded">
        {loading ? (initialData ? 'Guardando...' : 'Creando...') : (initialData ? 'Guardar Cambios' : 'Crear Cancha')}
      </button>
    </form>
  );
}